import { ResolvedFlags } from 'navigation/types';

import * as actionTypes from './actionTypes';

export const fetchFeatures = () => {
    return {
        type: actionTypes.FETCH_FEATURES_REQUEST,
    } as const;
};

export const setFeatures = (payload: Record<string, boolean>) => {
    return {
        type: actionTypes.SET_FEATURES,
        payload,
    } as const;
};

export const setFeaturesLoaded = (payload: boolean) => {
    return {
        type: actionTypes.SET_FEATURES_LOADED,
        payload,
    } as const;
};

export const setResolvedFlags = (payload: ResolvedFlags) => {
    return {
        type: actionTypes.SET_RESOLVED_FLAGS,
        payload,
    } as const;
};
